/*
stats about English syllables
generated from one of the englishPhonotactics tests
*/

export const englishSyllableCounts = {
  1: 16014,
  2: 57670,
  3: 34481,
  4: 12447,
  5: 3516,
  6: 743,
  7: 119,
  8: 15,
  9: 2,
  12: 1
}

export const englishOnsets = {
  '': 32601, ɫ: 21885, t: 19633, k: 19512, m: 19434, s: 17797, n: 17751, d: 17122, ɹ: 15496, b: 15044, p: 10042, h: 8213,
  f: 8195, v: 8072, ɡ: 7389, ʃ: 6506, st: 5480, z: 5229, w: 4928, dʒ: 4920, tʃ: 3531, sk: 2692, tɹ: 2590, j: 2339,
  bɹ: 2318, pɹ: 2218, kɹ: 2118, ɡɹ: 2031, kɫ: 1888, sp: 1521, θ: 1457, stɹ: 1254, fɹ: 1198, bɫ: 1196, dɹ: 1187, pɫ: 1173,
  kw: 1050, sɫ: 992, fɫ: 911, ɡɫ: 771, sm: 716, kj: 582, sw: 549, ð: 469, sn: 461, ʒ: 460, hw: 358, mj: 348, tw: 326,
  skɹ: 298, bj: 273, dw: 253, pj: 237, ɡw: 211, θɹ: 204, sf: 201, fj: 200, hj: 193, spɹ: 180, ʃɹ: 162, ʃm: 161, ɡj: 153,
  ʃɫ: 133, skw: 126, spɫ: 124, ʃw: 119, ʃn: 108, vj: 92, θw: 60, skɫ: 56, skj: 56, vw: 17, θj: 17, spj: 17, ʔ: 2
}

export const englishNuclei = {
  ə: 66258, ɪ: 44685, i: 32208, ɝ: 27246, ɛ: 25337, ɑ: 23526, æ: 20593, oʊ̯: 18083, eɪ̯: 12639,
  aɪ̯: 10767, ɔ: 10662, u: 9036, aʊ̯: 3211, ʊ: 2147, ɔɪ̯: 1208
}

export const englishCodas = {
  '': 169535, n: 28948, ɫ: 12988, z: 10735, k: 8454, ŋ: 7989, ɹ: 7946, t: 6355, d: 5910, m: 5463, s: 4645, nz: 3621,
  ts: 1969, ɡ: 1881, ɫz: 1858, p: 1793, nd: 1636, st: 1592, nt: 1576, ks: 1556, f: 1514, v: 1206, ɫd: 1162, b: 939,
  θ: 763, ʃ: 754, dz: 752, tʃ: 716, mz: 676, nts: 673, dʒ: 629, ɹt: 621, ns: 534, ɹd: 531, ɹz: 522, ŋk: 497, ŋz: 475,
  ps: 425, sts: 423, kt: 406, zd: 358, ɫt: 309, mp: 300, ndz: 294, ɹn: 292, vz: 241, ɡz: 225, ɹk: 200, ft: 193,
  bz: 192, pt: 185, fs: 177, ɫf: 146, ɫts: 143, ɹts: 138, md: 124, ɫdz: 120, ŋks: 117, sk: 116, ɹm: 114, ɹdz: 106,
  ntʃ: 102, ndʒ: 101, kts: 100, ʃt: 97, dʒd: 88, ɹs: 87, vd: 83, ɫk: 80, ɫm: 78, ɹks: 77, ɹf: 72, ɹp: 71, θs: 71,
  tʃt: 66, nst: 61, ɹθ: 57, ð: 55, kst: 52, ɡd: 51, ɹnz: 50, bd: 49, mps: 48, ɹmz: 47, ɹɫ: 45, ɹst: 45, ɹdʒ: 44,
  fts: 43, ɹɡ: 41, ʒ: 41, nθ: 39, ɫp: 38, ŋkt: 35, ɫs: 34, ɹtʃ: 34, mpt: 33, ɫmz: 31, ɹb: 27, ɹmd: 26, ɹʃ: 26,
  ndʒd: 25, sks: 25, ntʃt: 23, ɫθ: 22, ɫks: 21, ɫvz: 20, ɫv: 19, ɫfs: 19, ɹps: 19, sp: 18, ɫtʃ: 18, ɫb: 17, pts: 16,
  ŋd: 16, zm: 15, ɹkt: 15, ðz: 15, ɹɫz: 14, ɫvd: 13, ðd: 12, nθs: 12, ɹnd: 11, ɹdʒd: 11, mf: 11, ɹv: 9, ɫʃ: 9, ɫst: 8,
  skt: 8, ɹbz: 7, ɹfs: 7, ɫps: 7, ɫn: 6, ɹtʃt: 6, pst: 6, ɹnt: 5, ɹθs: 5, ɫdʒ: 5, ɹvz: 5, sps: 5, ɫpt: 5, ɹbd: 4,
  dθ: 4, ʒd: 4, ɫtʃt: 4, ɹɡz: 4, ɫkt: 4, ɹʒ: 4, nzd: 4, ɫmd: 4, spt: 4, ksts: 4, mpts: 4, ŋst: 3, ɹvd: 3, ɫbz: 3,
  ɫdʒd: 3, ɫθs: 3, ɫft: 3, ŋkθ: 3, ŋkθs: 3, ŋkts: 2, θt: 2, ttʃ: 2, ɹʃt: 2, pθ: 2, mt: 2, ɹft: 2, ɹɫd: 2, ɹpt: 2,
  dθs: 2, ɫnz: 2, mfs: 2, ɫfθ: 2, dst: 1, ŋkst: 1, tst: 1, pθs: 1, dʒz: 1, tθ: 1, tθs: 1, fθ: 1, mpst: 1, ɹð: 1,
  ɫpts: 1, ksθ: 1, ksθs: 1, mft: 1, ɹmθ: 1
}

export const englishFirstOnsets = {
  '': 18393, k: 9224, m: 8831, b: 6857, ɹ: 6727, d: 6582, s: 6477, h: 5838, ɫ: 5216, p: 5151, f: 3652, t: 3381, w: 3330,
  n: 3209, ɡ: 2995, v: 2261, dʒ: 2044, ʃ: 1927, st: 1833, pɹ: 1558, bɹ: 1538, kɹ: 1447, j: 1210, ɡɹ: 1190,
  tʃ: 1185, tɹ: 1129, kɫ: 952, z: 865, fɹ: 843, sp: 720, sk: 704, bɫ: 686, fɫ: 607, pɫ: 494, θ: 493, dɹ: 454, stɹ: 440,
  kw: 428, sɫ: 398, ɡɫ: 375, sw: 359, hw: 353, sn: 244, sm: 238, kj: 178, hj: 150, ʃɹ: 149, skɹ: 149, bj: 135, mj: 135, spɹ: 117,
  tw: 113, θɹ: 107, fj: 100, ʃw: 95, skw: 84, ʒ: 82, ʃɫ: 78, pj: 77, ɡw: 76, ʃm: 65, ð: 62, ʃn: 55, dw: 42, spɫ: 39, ɡj: 29,
  vj: 16, skj: 9, sf: 8, θw: 6, skɫ: 5, spj: 5, vw: 2, θj: 1, ʔ: 1
}

export const englishOtherOnsets = {
  ɫ: 16669, t: 16252, n: 14542, '': 14208, s: 11320, m: 10603, d: 10540, k: 10288, ɹ: 8769, b: 8187, v: 5811, p: 4891,
  ʃ: 4579, f: 4543, ɡ: 4394, z: 4364, st: 3647, dʒ: 2876, h: 2375, tʃ: 2346, sk: 1988, w: 1598, tɹ: 1461, j: 1129,
  θ: 964, kɫ: 936, ɡɹ: 841, stɹ: 814, sp: 801, bɹ: 780, dɹ: 733, pɫ: 679, kɹ: 671, pɹ: 660, kw: 622, sɫ: 594, bɫ: 510,
  sm: 478, ð: 407, kj: 404, ɡɫ: 396, ʒ: 378, fɹ: 355, fɫ: 304, sn: 217, tw: 213, mj: 213, dw: 211, sf: 193, sw: 190,
  pj: 160, skɹ: 149, bj: 138, ɡw: 135, ɡj: 124, fj: 100, θɹ: 97, ʃm: 96, spɫ: 85, vj: 76, spɹ: 63, ʃɫ: 55, θw: 54,
  ʃn: 53, skɫ: 51, skj: 47, hj: 43, skw: 42, ʃw: 24, θj: 16, vw: 15, ʃɹ: 13, spj: 12, hw: 5, ʔ: 1
}

export const englishLastCodas = {
  '': 36342, n: 13981, z: 10067, ɫ: 7090, ŋ: 5346, d: 4456, k: 4446, t: 4214, s: 3983, nz: 3463, m: 2321, ts: 1927, ɫz: 1775,
  ɹ: 1697, ks: 1471, st: 1353, nt: 1279, nd: 1201, ɫd: 1012, ɡ: 988, p: 876, v: 760, f: 756, dz: 726, nts: 670, mz: 651,
  ʃ: 601, θ: 536, ɹz: 507, tʃ: 501, ns: 490, dʒ: 488, ŋz: 449, ɹd: 434, sts: 423, ps: 422, b: 375, kt: 370, ɹt: 367, zd: 356,
  ŋk: 320, ndz: 287, vz: 239, ɫt: 214, ɡz: 210, bz: 189, fs: 177, pt: 173, ft: 171, ɹn: 156, ɹk: 147, mp: 131, ɹts: 128,
  ɫts: 128, md: 124, ŋks: 116, ɫdz: 111, sk: 103, kts: 100, ɹdz: 100, ʃt: 97, ɫf: 90, dʒd: 88, vd: 83, ndʒ: 78, ɹks: 73, θs: 70,
  ɹf: 69, ɹs: 68, ntʃ: 68, ɹm: 65, tʃt: 64, ɫk: 62, nst: 60, ɹp: 57, ɡd: 51, kst: 49, bd: 48, mps: 47, ɹnz: 47, ɹmz: 44,
  fts: 42, ɫm: 42, ɹθ: 40, ɹst: 39, ɹdʒ: 35, ð: 35, nθ: 34, ɹɡ: 33, mpt: 33, ŋkt: 32, ɹmd: 26, ɫmz: 25, ndʒd: 25, sks: 25,
  ɫp: 24, ɹb: 23, ntʃt: 23, ɫvz: 20, ʒ: 20, ɹps: 19, ɹʃ: 19, ɫfs: 18, ɫks: 18, ɹɫ: 17, ɹtʃ: 17, pts: 16, ɫtʃ: 16, ŋd: 16,
  ɫb: 16, ɫs: 16, sp: 15, zm: 15, ɹkt: 15, ɫv: 14, ðz: 14, ɫvd: 13, ðd: 12, nθs: 12, ɫθ: 11, ɹnd: 11, ɹdʒd: 11, ɹɫz: 11,
  mf: 10, ɹv: 9, ɫst: 8, skt: 8, ɫʃ: 8, ɹbz: 7, ɹfs: 7, ɫps: 7, ɹtʃt: 6, pst: 6, ɫn: 5, ɹθs: 5, ɫdʒ: 5, ɹvz: 5, sps: 5, ɫpt: 5,
  ɹbd: 4, dθ: 4, ʒd: 4, ɫtʃt: 4, ɫkt: 4, nzd: 4, ɫmd: 4, spt: 4, ksts: 4, mpts: 4, ŋst: 3, ɹnt: 3, ɹvd: 3, ɫbz: 3, ɫdʒd: 3, ɫθs: 3,
  ɹɡz: 3, ɫft: 3, ŋkθ: 3, ŋkθs: 3, ŋkts: 2, θt: 2, ttʃ: 2, ɹʃt: 2, ɹʒ: 2, pθ: 2, ɹft: 2, ɹɫd: 2, ɹpt: 2, dθs: 2,
  ɫnz: 2, mfs: 2, ɫfθ: 2, dst: 1, ŋkst: 1, tst: 1, pθs: 1, dʒz: 1, mt: 1, tθ: 1, tθs: 1, fθ: 1, mpst: 1, ɹð: 1, ɫpts: 1,
  ksθ: 1, ksθs: 1, mft: 1, ɹmθ: 1
}

export const englishOtherCodas = {
  '': 133193, n: 14967, ɹ: 6249, ɫ: 5898, k: 4008, m: 3142, ŋ: 2643, t: 2141, d: 1454, p: 917, ɡ: 893, f: 758, z: 668, s: 662,
  b: 564, v: 446, nd: 435, nt: 297, ɹt: 254, st: 239, θ: 227, tʃ: 215, ŋk: 177, mp: 169, nz: 158, ʃ: 153, ɫd: 150, dʒ: 141,
  ɹn: 136, ɹd: 97, ɫt: 95, ks: 85, ɫz: 83, ɫf: 56, ɹk: 53, ɹm: 49, ns: 44, ts: 42, kt: 36, ɫm: 36, ntʃ: 34, ɹɫ: 28, dz: 26,
  ŋz: 26, mz: 25, ndʒ: 23, ft: 22, ʒ: 21, ð: 20, ɹs: 19, ɫs: 18, ɫk: 18, ɹtʃ: 17, ɹθ: 17, ɫts: 15, ɹz: 15, ɡz: 15, ɹp: 14,
  ɫp: 14, sk: 13, pt: 12, ɫθ: 11, ɹts: 10, ɹdʒ: 9, ɫdz: 9, ɹɡ: 8, ɹʃ: 7, ndz: 7, ɹdz: 6, ɫmz: 6, ɹst: 6, nθ: 5, ɫv: 5,
  ɹb: 4, ɹks: 4, sp: 3, kst: 3, ps: 3, ɹɫz: 3, ŋkt: 3, ɹf: 3, ɹnz: 3, nts: 3, bz: 3, ɹmz: 3, ɫks: 3, ɫtʃ: 2, ɹnt: 2, ɹʒ: 2,
  zd: 2, vz: 2, tʃt: 2, bd: 1, mps: 1, ɹɡz: 1, ðz: 1, ɫb: 1, fts: 1, mt: 1, ɫn: 1, nst: 1, ɫʃ: 1, θs: 1, ŋks: 1, mf: 1, ɫfs: 1
}
